<div class="container eligibility-form">
    <div class="row">
        <div class="col-12">
            <form [formGroup]="eligibilityForm" novalidate>
                <section>
                    <div class="step">
                        <h1 class="mat-headline-large">Application type</h1>
                        <div class="group-section small-group">
                            <p class="mat-body-large section-title">
                                Will you be applying for personal or business finance?
                                <span class="mat-body-medium section-subtitle">
                                    You should apply for a business loan if the vehicle you are purchasing will be
                                    used at least 50% of the time for business purposes.
                                </span>
                            </p>
                            <mat-button-toggle-group class="button-group"
                                [formControl]="eligibilityForm.controls.applicationType" aria-label="Application type"
                                [hideSingleSelectionIndicator]="true">
                                <mat-button-toggle [value]="ApplicationType.Personal">Personal</mat-button-toggle>
                                <mat-button-toggle [value]="ApplicationType.Business">Business</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <ng-container *ngIf="eligibilityForm.controls.applicationType.value === ApplicationType.Business">
                        <div class="info-box warning-box">
                            <p class="mat-body-large">
                                To determine eligibility for business finance you'll need to complete a full Avanti
                                finance application.
                            </p>
                            <div class="button-row">
                                <button mat-flat-button type="button" (click)="applyNow()">Apply now</button>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showAgeStep && isStepRevealed(1)">
                        <hr class="separator no-margin" />
                        <div class="step">
                            <h1 class="mat-headline-large">Age</h1>
                            <div class="group-section small-group">
                                <p class="mat-body-large section-title">Are you 18 years of age or older?</p>
                                <mat-button-toggle-group class="button-group"
                                    [formControl]="eligibilityForm.controls.isOver18" aria-label="Age verification"
                                    [hideSingleSelectionIndicator]="true">
                                    <mat-button-toggle [value]="UserAction.Yes">Yes</mat-button-toggle>
                                    <mat-button-toggle [value]="UserAction.No">No</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <div class="info-box warning-box"
                            *ngIf="eligibilityForm.controls.isOver18.value === UserAction.No">
                            <p class="mat-body-large">
                                You must be aged 18 or older to apply for finance in New Zealand.
                            </p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showResidencyStep && isStepRevealed(2)">
                        <hr class="separator no-margin" />
                        <div class="step">
                            <h1 class="mat-headline-large">Residency</h1>
                            <div class="group-section small-group">
                                <p class="mat-body-large section-title">
                                    What is your residency status in New Zealand?
                                </p>
                                <mat-button-toggle-group class="button-group button-group-wrap"
                                    [formControl]="eligibilityForm.controls.residencyStatus"
                                    aria-label="Residency status" [hideSingleSelectionIndicator]="true">
                                    <mat-button-toggle [value]="ResidencyStatus.NZCitizenOrPermanentResident">NZ citizen
                                        or permanent resident</mat-button-toggle>
                                    <mat-button-toggle [value]="ResidencyStatus.WorkVisa">Work visa</mat-button-toggle>
                                    <mat-button-toggle [value]="ResidencyStatus.StudentOrVisitorVisa">Student or visitor
                                        visa</mat-button-toggle>
                                    <mat-button-toggle [value]="ResidencyStatus.OtherStatus">Other
                                        status</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <div class="info-box info-box-blue"
                            *ngIf="eligibilityForm.controls.residencyStatus.value === ResidencyStatus.WorkVisa">
                            <p class="mat-body-large">
                                Your eligibility for finance with Avanti Finance may depend on your specific visa
                                conditions and remaining duration. They will ask you for these details during the
                                application process.
                            </p>
                        </div>

                        <div class="info-box warning-box" *ngIf="eligibilityForm.controls.residencyStatus.value === ResidencyStatus.StudentOrVisitorVisa ||
                                   eligibilityForm.controls.residencyStatus.value === ResidencyStatus.OtherStatus">
                            <p class="mat-body-large">
                                Based on your selected residency status, Avanti Finance isn't able to offer vehicle
                                finance at this time. However, one of our other finance partners may be able to help -
                                leave your details below and we'll be in touch.
                            </p>
                            <div class="button-row">
                                <button mat-flat-button type="button" (click)="openEnquiryForm()">Enquire with
                                    us</button>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showLoanStep && isStepRevealed(3)">
                        <hr class="separator no-margin" />
                        <div class="step">
                            <h1 class="mat-headline-large">Vehicle and loan details</h1>
                            <div class="loan-fields">
                                <app-form-field-currency label="Vehicle purchase price"
                                    [control]="eligibilityForm.controls.vehiclePrice" [decimal_precision]="0">
                                </app-form-field-currency>

                                <app-form-field-currency label="Accessories / extras"
                                    [control]="eligibilityForm.controls.accessories" [decimal_precision]="0">
                                </app-form-field-currency>

                                <app-form-field-currency label="Deposit" [control]="eligibilityForm.controls.deposit"
                                    [decimal_precision]="0">
                                </app-form-field-currency>

                                <app-form-field-currency label="Estimated trade-in value"
                                    [control]="eligibilityForm.controls.tradeIn" [decimal_precision]="0">
                                </app-form-field-currency>
                            </div>

                            <div class="group-section info-box">
                                <div class="flex-content">
                                    <span class="mat-body-large">Vehicle cost</span>
                                    <span class="mat-body-large">{{ (eligibilityForm.controls.vehiclePrice.value ?? 0) |
                                        currency }}</span>
                                </div>
                                <div class="flex-content">
                                    <span class="mat-body-large">Other items</span>
                                    <span class="mat-body-large">{{ (eligibilityForm.controls.accessories.value ?? 0) |
                                        currency }}</span>
                                </div>
                                <div class="flex-content">
                                    <span class="mat-body-large"><em>Less</em> cash deposit</span>
                                    <span class="mat-body-large">{{ (eligibilityForm.controls.deposit.value ?? 0) |
                                        currency }}</span>
                                </div>
                                <div class="flex-content">
                                    <span class="mat-body-large">
                                        <em>Less</em> net trade in value
                                        <button type="button" mat-icon-button class="info-tooltip"
                                            matTooltip="Estimated value of your trade in vehicle less any finance you currently owe on it"
                                            matTooltipPosition="right">
                                            <mat-icon svgIcon="info"></mat-icon>
                                        </button>
                                    </span>
                                    <span class="mat-body-large">{{ (eligibilityForm.controls.tradeIn.value ?? 0) |
                                        currency }}</span>
                                </div>
                                <hr class="separator no-margin" />
                                <div class="flex-content">
                                    <div>
                                        <div class="mat-title-medium black-font">Total amount to borrow</div>
                                        <div class="mat-body-small black-font no-letterspace">Excludes any applicable
                                            loan related fees</div>
                                    </div>
                                    <div class="mat-headline-large">{{ loanAmount | currency }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="info-box warning-box" *ngIf="showLoanExit">
                            <p class="mat-body-large">
                                <strong>Based on the details provided, the estimated loan amount is below the minimum
                                    that Avanti Finance is able to offer.</strong>
                            </p>
                            <p class="mat-body-large">
                                However, we may have other finance options available for smaller loan amounts —
                                leave your details with us and we'll be in touch to discuss what might be possible.
                            </p>
                            <div class="button-row">
                                <button mat-flat-button type="button" (click)="openEnquiryForm()">Enquire with
                                    us</button>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showEmploymentStep && isStepRevealed(4)">
                        <hr class="separator no-margin" />
                        <div class="step">
                            <h1 class="mat-headline-large">Employment</h1>
                            <div class="group-section small-group">
                                <p class="mat-body-large section-title">
                                    What is your current employment status?
                                </p>
                                <mat-button-toggle-group class="button-group button-group-wrap"
                                    [formControl]="eligibilityForm.controls.employmentStatus"
                                    aria-label="Employment status" [hideSingleSelectionIndicator]="true">
                                    <mat-button-toggle [value]="EmploymentStatus.Employed">Employed</mat-button-toggle>
                                    <mat-button-toggle
                                        [value]="EmploymentStatus.SelfEmployed">Self-employed</mat-button-toggle>
                                    <mat-button-toggle [value]="EmploymentStatus.Unemployed">Not
                                        employed</mat-button-toggle>
                                    <mat-button-toggle value="Other">Other</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>

                            <div class="group-section small-group"
                                *ngIf="eligibilityForm.controls.employmentStatus.value === EmploymentStatus.Employed || eligibilityForm.controls.employmentStatus.value === EmploymentStatus.SelfEmployed">
                                <p class="mat-body-large section-title">What is your employment basis?</p>
                                <mat-button-toggle-group class="button-group button-group-wrap"
                                    [formControl]="eligibilityForm.controls.employmentBasis"
                                    aria-label="Employment basis" [hideSingleSelectionIndicator]="true">
                                    <mat-button-toggle [value]="EmploymentBasis.FullTime">Full time</mat-button-toggle>
                                    <mat-button-toggle [value]="EmploymentBasis.PartTime">Part time</mat-button-toggle>
                                    <ng-container
                                        *ngIf="eligibilityForm.controls.employmentStatus.value === EmploymentStatus.Employed">
                                        <mat-button-toggle
                                            [value]="EmploymentBasis.Contract">Contract</mat-button-toggle>
                                        <mat-button-toggle [value]="EmploymentBasis.Casual">Casual</mat-button-toggle>
                                        <mat-button-toggle
                                            [value]="EmploymentBasis.Seasonal">Seasonal</mat-button-toggle>
                                    </ng-container>
                                </mat-button-toggle-group>
                            </div>

                            <div class="group-section small-group"
                                *ngIf="eligibilityForm.controls.employmentStatus.value === EmploymentStatus.Unemployed">
                                <p class="mat-body-large section-title">Please select from one of the following</p>
                                <mat-button-toggle-group class="button-group button-group-wrap"
                                    [formControl]="eligibilityForm.controls.unemploymentStatus"
                                    aria-label="Unemployment status" [hideSingleSelectionIndicator]="true">
                                    <mat-button-toggle
                                        [value]="UnemploymentStatusEnum.Beneficiary">Beneficiary</mat-button-toggle>
                                    <mat-button-toggle
                                        [value]="UnemploymentStatusEnum.Superannuation">Superannuation</mat-button-toggle>
                                    <mat-button-toggle
                                        [value]="UnemploymentStatusEnum.SelfFunding">Self-funding</mat-button-toggle>
                                    <mat-button-toggle value="Student">Student</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showServiceabilityStep && isStepRevealed(5)">
                        <hr class="separator no-margin" />
                        <div class="step">
                            <h1 class="mat-headline-large">Serviceability</h1>
                            <div class="group-section large-group">
                                <div class="group-section small-group">
                                    <p class="mat-body-large section-title no-margin">
                                        Can you comfortably afford a repayment amount of approximately
                                        <strong>${{ weeklyRepayment | number:'1.0-0' }}</strong> per week?
                                    </p>
                                    <div>
                                    <div class="info-box info-box-blue">
                                        <p class="mat-body-large">
                                            Note: For a <strong>{{ loanAmount | currency }}</strong> loan, based on a <strong>{{ loanTermMonths }}-month</strong> term at a
                                            typical
                                            interest rate of
                                            <strong>{{ annualInterestRatePct }}% p.a.</strong> and typical fees, your
                                            estimated weekly repayments
                                            are <strong>${{ weeklyRepayment | number:'1.0-0' }}</strong>.<br>
                                            <small>Total repayments: {{
                                        totalAmountRepayable | currency:'NZD':'symbol':'1.2-2' }}.</small>
                                        </p>
                                    </div>
                                    <mat-button-toggle-group class="button-group button-group-stack"
                                        [formControl]="eligibilityForm.controls.serviceabilityOption"
                                        aria-label="Serviceability" [hideSingleSelectionIndicator]="true">
                                        <mat-button-toggle [value]="ServiceabilityOption.Comfortable">Yes, that's
                                            comfortably within my budget</mat-button-toggle>
                                        <mat-button-toggle [value]="ServiceabilityOption.Manageable">It's manageable but
                                            would be a stretch</mat-button-toggle>
                                        <mat-button-toggle [value]="ServiceabilityOption.Tight">It would be very tight —
                                            I'd
                                            struggle</mat-button-toggle>
                                        <mat-button-toggle [value]="ServiceabilityOption.Cannot">No, I can't afford
                                            that</mat-button-toggle>
                                    </mat-button-toggle-group>
                                    </div>
                                </div>
                                <div class="disclaimer-text">
                                    <p>This repayment figure is an <strong>estimate only</strong> and does not
                                        constitute an offer of finance or financial advice.</p>
                                    <p>Calculations are based on an example interest rate of {{ annualInterestRatePct
                                        }}% p.a., an example
                                        loan term of {{ loanTermMonths }} months,
                                        {{ eligibilityForm.controls.deposit.value
                                            ? 'a deposit of ' + (eligibilityForm.controls.deposit.value | currency:'NZD':'symbol':'1.0-0')
                                            : 'no deposit' }}{{ eligibilityForm.controls.tradeIn.value
                                            ? ', estimated trade-in value of ' + (eligibilityForm.controls.tradeIn.value | currency:'NZD':'symbol':'1.0-0')
                                            : '' }}, and example standard fees
                                        including an
                                        account admin fee of {{ monthlyAdminFee | currency:'NZD':'symbol':'1.2-2'  }} per month and establishment fee of
                                        {{ establishmentFee | currency:'NZD':'symbol':'1.0-0' }} (usually paid upfront
                                        or added to the loan). Total amount repayable: {{
                                        totalAmountRepayable | currency:'NZD':'symbol':'1.2-2' }}.</p>
                                    <p>Other lender-specific fees may apply. Your actual interest rate, fees, and
                                        repayments will differ depending on your credit profile, chosen lender, and
                                        responsible lending assessment.</p>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showCreditHistoryStep && isStepRevealed(6)">
                        <hr class="separator no-margin" />
                        <div class="step">
                            <h1 class="mat-headline-large">Credit history</h1>
                            <div class="group-section small-group">
                                <p class="mat-body-large section-title">
                                    How would you describe your credit history?
                                    <span class="mat-body-medium section-subtitle">
                                        Please answer honestly — providing inaccurate information may affect your
                                        application.
                                    </span>
                                </p>
                                <mat-button-toggle-group class="button-group button-group-wrap"
                                    [formControl]="eligibilityForm.controls.creditHistory" aria-label="Credit history"
                                    [hideSingleSelectionIndicator]="true">
                                    <mat-button-toggle [value]="CreditHistory.VeryGood">Very good — I always pay on
                                        time, no issues</mat-button-toggle>
                                    <mat-button-toggle [value]="CreditHistory.Good">Good — the odd late payment but
                                        generally fine</mat-button-toggle>
                                    <mat-button-toggle [value]="CreditHistory.Mixed">Mixed — I've had some issues in the
                                        past</mat-button-toggle>
                                    <mat-button-toggle [value]="CreditHistory.Poor">Poor — I know I have defaults or
                                        collections</mat-button-toggle>
                                    <mat-button-toggle [value]="CreditHistory.NotSure">Not sure — I've never
                                        checked</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>

                            <div class="group-section small-group" *ngIf="creditHistoryNeedsFollowUp">
                                <div>
                                    <p class="mat-body-large section-title">
                                        Do any of the following currently apply to you?
                                    </p>
                                    <ul class="credit-issues-list mat-body-large">
                                        <li>I have current unpaid debts, judgements, or legal matters</li>
                                        <li>I have recently been declared bankrupt or entered into an insolvency
                                            arrangement
                                        </li>
                                        <li>I am currently behind on one or more existing credit repayments</li>
                                    </ul>
                                </div>
                                <mat-button-toggle-group class="button-group"
                                    [formControl]="eligibilityForm.controls.hasCreditIssues" aria-label="Credit issues"
                                    [hideSingleSelectionIndicator]="true">
                                    <mat-button-toggle [value]="UserAction.Yes">Yes</mat-button-toggle>
                                    <mat-button-toggle [value]="UserAction.No">No</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                        <!-- Credit-issues exit message now shown in the result popup (ResultDialogComponent). -->
                    </ng-container>

                    <!-- Submit reveals the result in a popup (ResultDialogComponent). -->
                    <ng-container *ngIf="resultOutcome">
                        <hr class="separator no-margin" />
                        <div class="step">
                            <div class="button-row">
                                <button mat-flat-button type="button" (click)="submitResult()">Submit</button>
                            </div>
                        </div>
                    </ng-container>
                </section>
            </form>
        </div>
    </div>
</div>